<template>
	<div class="pagination" aria-label="Page navigation">
		<ul class="pagination-list">
			<li class="page-item" :class="{'disabled':value === 1}">
				<a class="page-link" aria-label="Previous" @click="backClick">
					<span aria-hidden="true">{{translations.terms.previousPage}}</span>
				</a>
			</li>
			<li v-for="(item, index) in visiblePages" :key="index" :class="{active:item === value}" class="page-item" >
				<a class="page-link" @click="goToPage(item)">{{item}}</a>
			</li>
			<li class="page-item" :class="{'disabled':value === maxPages}">
				<a class="page-link" aria-label="Next" @click="forwardClick">
					<span aria-hidden="true">{{translations.terms.nextPage}}</span>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		name: "PaginationList",
		computed: {
			...mapState({
				translations: 'translations'
			}),
			visiblePages(){
				let visible = [];
				
				const pageUpperDelimiter = this.value + 4;
				const pageLowerDelimiter = this.value - 4;
				const maxPagesDelimiter = this.maxPages - 1;
				
				for(let i = 1; i <= this.maxPages; i++)
				{
					if (i <= 1 || i > maxPagesDelimiter || (i < pageUpperDelimiter && i > pageLowerDelimiter))
					{
						visible.push(i);
					}
					else if (visible[visible.length-1] !== '...')
					{
						visible.push('...');
					}
				}
				
				return visible;
			},
		},
		methods: {
			backClick()
			{
				if(this.value !== 1){
					this.$emit('input', this.value-1)
				}
			},
			forwardClick()
			{
				if(this.value !== this.maxPages){
					this.$emit('input', this.value+1)
				}
			},
			goToPage(pageNumber){
				if(pageNumber !== "..."){
					this.$emit('input', pageNumber)
				}
			}
		},
		props:{
			value: Number,
			maxPages: Number,
		},
	}
</script>

<style lang="scss" scoped>
	.pagination{
		text-align: center;
		.pagination-list{
			padding: 0;
			margin: 0;
			li{
				background-image: none !important;
				padding-left: 0 !important;
			}
			.page-item{
				list-style: none;
				display: inline-block;
				.page-link{
					padding: 5px 10px;
					font-size: 12px;
					cursor: pointer;
				}
				&.disabled{
					.page-link{
						color: #b6b6b6;
					}
				}
				&.active{
					.page-link{
						font-size: 16px;
						font-weight: 700;
					}
				}
			}
		}
	}
</style>
